<template>
  <v-card class="m-5 mb-1">
        <!-- <v-layout @click="toGroup1" row wrap class="mt-0 cardCursor">
            <v-flex xs12>
        <v-card-media
          class="mr-0 pt-0"
          height="26vh"
          :src="group.imgUrl[0].url+'_card'">
          <div class="overlay-image" ></div>
        </v-card-media>
        
        </v-flex>
        <div class="div3 group-div">
        <v-card-title class="pt-0 "  style="text-align:left">
            <a @click="toGroup" style="text-decoration:none; cursor:pointer" ><div class="title headline group-title mt-3" >{{group.title.slice(0, 14)}}<span v-if="group.title.length >14">...</span></div></a>  <br>
            <p class="subheading group-subheading" style="text-align:left">{{group.description.slice(0, 80)}}<span v-if="group.description.length >79">...</span></p>    
 
        </v-card-title>
        </div>
        </v-layout> -->

        <v-card-media @click="toGroup1"
                :src="group.imgUrl[0].url+'_card'"
                height="180px"
              > <div class="overlay-image" ><v-container fill-height fluid>
                  <v-layout fill-height wrap>
                    <v-flex xs12 align-end flexbox>
                      <span @click="toGroup" style="text-decoration:none; cursor:pointer" class="headline grpTitle white--text" v-text="group.title[lang]"> </span>
                      <br>
                      <p class="grpText white--text" style="margin-top:10px"> {{group.description[lang].slice(0, 110)}}<span v-if="group.description[lang].length >109">...</span> </p>                    
                    </v-flex>
                    <!-- <v-flex xs12 align-end flexbox>
                    </v-flex> -->
                  </v-layout>
                </v-container>
                </div>
                
                
              </v-card-media>
        <hr class="hrstl3">
        <v-expansion-panel class="expPanel"  v-if="showContentGroup(group)" expand >
            <v-expansion-panel-content class="mb-0 " style="    width: 100%;"> 



                 <div class="greyText" slot="header"><v-icon left class="pr-2">view_day</v-icon>{{gLang[lang].groupCard.expansion}}</div>
  
              <v-layout row>
    <v-flex xs12 >
      <v-card>
        <v-list two-line>
          <template >
            <div  v-for="(collection,i) in relatedCollections" :key="i"  v-if="(collection.groups.indexOf(group.title.en) > -1)">
            <v-divider ></v-divider> 
            <v-list-tile @click="toCollection(collection._id)" avatar v-if="i<3" class="pt-2 pb-0" >
              <v-list-tile-avatar>
                <img v-bind:src="collection.imgUrl[0].url+'_card'"/>
              </v-list-tile-avatar>
              <v-list-tile-content class="collection-list-ie pt-1" >
                <v-list-tile-title class="artTitle" v-html="collection.title[lang]" style="overflow:hidden"></v-list-tile-title>
                <v-list-tile-sub-title v-html="collection.description[lang]"></v-list-tile-sub-title>
                
                             
              </v-list-tile-content>
              
            </v-list-tile>
            </div>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>








<!-- 


              <v-card>
        <div   class="greyback">
        <div  v-for="collection in collections" :key="collection._id" >
            <div v-if="(collection.groups.indexOf(group.title) > -1)">
            <v-layout row wrap>
                <v-flex xs12> 
                    <v-layout row wrap>
                        
                      <v-flex xs3>
                        <v-card-media
                         :src="collection.imgUrl[0].url" alt="" width="80%;" class="pl-3 ml-1" height="40px" contain >
                        </v-card-media>
                      </v-flex>  
                      <v-flex xs9>
                    <p class="mb-0"><strong>{{ minimize(collection.title,4)}} </strong></p>
                    <p class="mb-0"> <span class="pstl">  {{minimize(collection.description,5)}}</span></p>
          
                      </v-flex> 
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>
        </div>
        </div>
              </v-card> -->
            </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>
</template>


<script>


export default {
    data () {
        return {

        }
    },
    props: ['group', 'collections',"clickImage"],
    methods: {
      toGroup(){
        this.$router.push('/groups/'+this.group._id)
      },
      toGroup1(){
        if (this.clickImage != false)
        this.$router.push('/groups/'+this.group._id)
        if(window.innerWidth>950)
        this.$router.push('/groups/'+this.group._id)
      },
       toCollection(collectionID) {
        this.$router.push('/collections/'+collectionID);
      },
        showContentGroup(group) { 

        // console.log(this.artefacts);
        // console.log(this.artefacts[6]);
        // console.log(this.artefacts.length);
        var i;
        for(i=0; i< this.collections.length; i++) { 
          if(this.collections[i].groups.indexOf(group.title.en) > -1) {
              return true;
         }
         }
         return false;
        },
        minimize(str, spaces) {
            if (str.split(" ").length < spaces) 
                return str;
            else
                return (
                    str
                    .split(" ")
                    .slice(0, spaces - 1)
                    .join(" ") + "..."
        );
    }

    },
    computed : {
      lang() {
      return this.$store.getters.loadLang;
    },
    gLang() {
      return this.$store.getters.loadGlobLang;
    },
      relatedCollections() {
      return this.$store.getters.loadRelatedCollections(this.group.title.en)
    },
    }

  
}
</script>
<style>
.expPanel .expansion-panel__container .expansion-panel__header {
  padding-left:15px;
}

.artTitle{
  font-weight:600;
}

.greyText{
  color:rgba(0, 0, 0, 0.54)
;
}

</style>


<style scoped>

.grpText{
  color:rgba(255, 255, 255, 0.8)!important;
}

.grpTitle{
  font-weight:500;
}

/* @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) { */
    .collection-list-ie {
      display: inline;
    }
/* } */

@media screen and (min-width:950px) { 
.cardCursor:hover { 
  cursor:pointer;
}
}
.group-title{
  color:white;
    font-size: 2.2em !important;
    top:3%;
}

.group-subheading { 
position:relative;


        font-size: 1.06em !important;

        color: white;

}

.collection-title { 
  color:black;
    font-size: 2em !important;
    top:3%;
}

.collection-subheading {
    position: absolute;

        font-size: 1.06em !important;
    top: 101%;
        left: 4%;
        color: black;

}

.headline {

      -webkit-text-stroke-width: 0.3px;
    -webkit-text-stroke-color: black;
}


.overlay-image {  

  position:absolute; 
  background-color: rgba(0,0,0,0.5); 
  width:100%; 
  height:100%;
}



.headline-artefact {
    position: absolute;
    bottom: 3%;
    left: 3%;
    -webkit-text-stroke-width: 0.3px;
    -webkit-text-stroke-color: black;
  }
  .div1 { 
    position:absolute; width:67%; top: 4%;
  }

  .hrstl { 
    color:#efefef; border-style:solid;
  }

  .spanstl { 
    color:#B0B0B0;
  }

  .hrstl2 {
    color:#ddd; border-style:solid;
  }

  .div2 { 
    position:absolute; width:100%; top: 9%;
  }

  .hrstl3 { 
    color:#efefef; border-style:solid;
  }

  .pstl {
    color:#B0B0B0;
  }

  .hrstl4 {
    color:#ddd; border-style:solid;
  }

  .div3 { 
    position:absolute; width:67%; top: 4%;
  }

  .group-div {
    width: 100%;
    top:6% !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Partials/GroupCard.vue